import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { storeToRefs } from "pinia";

import FacilitatorOrganisationDashboard from "@/components/dashboards/FacilitatorOrganisationDashboard.vue";
import SelectMarketingPreferencesModal from "@/components/modals/SelectMarketingPreferencesModal.vue";
import TrainerOrganisationDashboard from "@/components/dashboards/TrainerOrganisationDashboard.vue";
import ProfessionalDashboard from "@/components/dashboards/ProfessionalDashboard.vue";
import CoursesAdminDashboard from "@/components/dashboards/CoursesAdminDashboard.vue";
import FacilitatorDashboard from "@/components/dashboards/FacilitatorDashboard.vue";
import UsersAdminDashboard from "@/components/dashboards/UsersAdminDashboard.vue";
import ClubsAdminDashboard from "@/components/dashboards/ClubsAdminDashboard.vue";
import InitiateDashboard from "@/components/dashboards/InitiateDashboard.vue";
import TrainerDashboard from "@/components/dashboards/TrainerDashboard.vue";
import ParentDashboard from "@/components/dashboards/ParentDashboard.vue";
import AdminDashboard from "@/components/dashboards/AdminDashboard.vue";
import SubscriptionBanner from "@/components/dashboards/SubscriptionBanner.vue";
import ActionsCard from "@/components/ActionsCard.vue";
import RoleGuard from "@/components/RoleGuard.vue";

import { useGlobalStore, useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const { user } = storeToRefs(useUserStore());
const { showMarketingPreferences } = storeToRefs(useGlobalStore());

const isMarketingModalOpen = ref(false);

if (!user.value.has_completed_marketing_material && showMarketingPreferences.value && !userHasRole(user.value.roles, ["admin", "users-admin", "courses-admin", "clubs-admin"])) {
  isMarketingModalOpen.value = true;
  showMarketingPreferences.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SelectMarketingPreferencesModal, {
      "is-open": isMarketingModalOpen.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isMarketingModalOpen.value = false))
    }, null, 8, ["is-open"]),
    _createVNode(RoleGuard, { roles: [
        'certified-facilitator',
        'certified-facilitator-trainee',
        'professional',
        'paid-professional',
        'advanced-facilitator',
        'advanced-facilitator-trainee',
        'l3-trainee',
        'l3-specialist',
        'l4a-trainee',
        'l4b-trainee',
        'l4a-trainer',
        'l4b-mentor'
      ] }, {
      default: _withCtx(() => [
        _createVNode(ActionsCard)
      ]),
      _: 1
    }),
    _createVNode(SubscriptionBanner, { class: "mt-4" }),
    _createVNode(RoleGuard, { roles: ['admin'] }, {
      default: _withCtx(() => [
        _createVNode(AdminDashboard)
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['users-admin'] }, {
      default: _withCtx(() => [
        _createVNode(UsersAdminDashboard)
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['courses-admin'] }, {
      default: _withCtx(() => [
        _createVNode(CoursesAdminDashboard)
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['clubs-admin'] }, {
      default: _withCtx(() => [
        _createVNode(ClubsAdminDashboard)
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['trainer-organisation'] }, {
      default: _withCtx(() => [
        _createVNode(TrainerOrganisationDashboard)
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['facilitator-organisation'] }, {
      default: _withCtx(() => [
        _createVNode(FacilitatorOrganisationDashboard)
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['l4a-trainer'] }, {
      default: _withCtx(() => [
        _createVNode(TrainerDashboard)
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['advanced-facilitator', 'advanced-facilitator-trainee', 'l4a-trainee'] }, {
      default: _withCtx(() => [
        _createVNode(FacilitatorDashboard)
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['certified-facilitator', 'certified-facilitator-trainee'] }, {
      default: _withCtx(() => [
        _createVNode(InitiateDashboard)
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['professional', 'paid-professional'] }, {
      default: _withCtx(() => [
        _createVNode(ProfessionalDashboard)
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['parent', 'brick-club-family'] }, {
      default: _withCtx(() => [
        _createVNode(ParentDashboard)
      ]),
      _: 1
    })
  ]))
}
}

})